import React from "react";
import { DataGrid } from "@material-ui/data-grid";
import "../../css/style.css";
import App from "../App";
import { CUSTOM_SEARCH_BAR } from "./constants";
const SearchResult = ({
  rows,
  columns,
  lang,
  familyData,
  logged,
  express,
  tariff,
  sortDirection,
  sortField,
  price_sort,
  isFamilyFlag,
  client_country_id,
  jwt,
  elementId,
  api_url,
  api_origin,
  customFilterManufacturer,
  customFilterManufacturerIds,  
  showAddToCart,
  showAddToList,
  cart_products,
  fav_products,
  searchQuery,
  resultsFields,
  showSelectButton,
  showPlusButton,
  showPlusQtyButton,
  selectedProductsCode,
  openProduct,
  openOn,
  onProductSelected,
  onProductAddedToCart,
  onProductQtyModifiedOnCart,
  onProductDeletedFromCart,
  onProductAddedToList,  
  ...props
}) => {
  return (
    <App
      from={CUSTOM_SEARCH_BAR}
      data={rows}
      showAddToCart={showAddToCart}
      showAddToList={showAddToList}
      logged={logged}
      express={express}
      tariff={tariff}
      client_country_id={client_country_id}
      jwt={jwt}
      elementId={elementId}
      api_url={api_url}
      api_origin={api_origin}
      typeView={"table"}
      sortDirection={sortDirection}
      sortField={sortField}
      price_sort={price_sort}
      isFamilyFlag={isFamilyFlag}
      lang={lang}
      family_list={familyData}
      resultsFields={resultsFields}
      cart_products={cart_products}
      fav_products={fav_products}
      resultSearchTerm={searchQuery}
      showSelectButton={showSelectButton}
      showPlusQtyButton={showPlusQtyButton}
      showPlusButton={showPlusButton}
      handleSelectedProductClick={props.handleSelectedProductClick}
      customFilterManufacturer={customFilterManufacturer}
      customFilterManufacturerIds={customFilterManufacturerIds}      
      selectedProductsCode={selectedProductsCode}
      onProductSelected={onProductSelected}
      onProductAddedToCart={onProductAddedToCart}
      onProductQtyModifiedOnCart={onProductQtyModifiedOnCart}
      onProductDeletedFromCart={onProductDeletedFromCart}
      onProductAddedToList={onProductAddedToList}
      openProduct={openProduct}
      openOn={openOn}      
    />
  );
};

export default SearchResult;
